/* eslint-disable camelcase */
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Icon } from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cookie from 'js-cookie';
import s from './Navigation.css';

class Navigation extends React.Component {
  static propTypes = {
    user: PropTypes.shape().isRequired,
    enabledModel: PropTypes.array.isRequired,
  };
  state = {};
  logout = () => {
    cookie.set('AUTH', '');
    const { enabledModel } = this.props;
    const enableSSO = enabledModel && enabledModel.indexOf('oauth2') !== -1;
    setTimeout(() => {
      window.location.href = enableSSO ? window.G.oauth2.logout : '/login';
    });
  };
  render() {
    const menu = (
      <Menu>
        <Menu.Item>
          <a onClick={this.logout}>退出</a>
        </Menu.Item>
      </Menu>
    );
    const { user } = this.props;
    return (
      <div className={s.wrap}>
        <ul className={cn(s.nav, 'clearfix')}>
          <li>
            {user.id !== undefined ? (
              <Dropdown overlay={menu}>
                <a className="ant-dropdown-link" href="#">
                  {user.name} <Icon type="down" />
                </a>
              </Dropdown>
            ) : (
              <a href="/admin">登录</a>
            )}
          </li>
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(Navigation);
